export type PlaybackSpeed = 1 | 2 | 5 | 10;

export class PlaybackScheduler {
  private speed: PlaybackSpeed;
  constructor(opts: { speed: PlaybackSpeed }){ this.speed = opts.speed; }
  setSpeed(speed: PlaybackSpeed){ this.speed = speed; }
  getBatchSize(): number {
    switch(this.speed){
      case 1: return 1;
      case 2: return 4;
      case 5: return 10;
      case 10: return 25;
      default: return 1;
    }
  }
  getFrameDelayMs(): number { return this.speed >=5 ? 8 : 16; }
}
